/**
 * Third-party vendor accent colours used for decorative avatars/badges on
 * marketing surfaces. One shared map so the landing badge and the public
 * catalog never disagree about a vendor's colour. Decorative only — never
 * used for status or meaning.
 */
export const VENDOR_COLORS: Record<string, string> = {
  OpenAI: "#74AA9C",
  Anthropic: "#D97757",
  Google: "#4285F4",
  DeepSeek: "#536AF5",
  Mistral: "#FF7000",
  MiniMax: "#FA5210",
  Meta: "#0668E1",
  Alibaba: "#FF6A00",
  Baidu: "#2932E1",
  Tencent: "#00C2FF",
};

export function vendorColor(vendor: string): string {
  if (VENDOR_COLORS[vendor]) return VENDOR_COLORS[vendor];
  if (!vendor) return "var(--as-muted)";
  let hash = 0;
  for (let i = 0; i < vendor.length; i++) hash = (hash * 31 + vendor.charCodeAt(i)) >>> 0;
  const palette = Object.values(VENDOR_COLORS);
  return palette[hash % palette.length] ?? "var(--as-muted)";
}
